import { render, staticRenderFns } from "./qr_code_elevator.vue?vue&type=template&id=1c18748f&scoped=true&"
import script from "./qr_code_elevator.vue?vue&type=script&lang=js&"
export * from "./qr_code_elevator.vue?vue&type=script&lang=js&"
import style0 from "./qr_code_elevator.vue?vue&type=style&index=0&id=1c18748f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18748f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VContainer,VFlex,VImg,VLayout,VSpacer,VToolbar,VToolbarTitle})
